import { useEffect, useCallback } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
    __MP_PIXEL_LOADED__?: boolean
    __MP_PAGEVIEW_SENT__?: boolean
  }
}

const PIXEL_ID = '1467545731386072'

function loadPixelScript() {
  if (typeof window === 'undefined') return
  if (window.__MP_PIXEL_LOADED__) return

  function fbq(...args: any[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  }

  ;(fbq as any).push = fbq
  ;(fbq as any).loaded = true
  ;(fbq as any).version = '2.0'
  ;(fbq as any).queue = [] as any[]

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
  window.__MP_PIXEL_LOADED__ = true
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()

    if (!window.__MP_PAGEVIEW_SENT__ && window.fbq) {
      window.fbq('track', 'PageView')
      window.__MP_PAGEVIEW_SENT__ = true
    }
  }, [])

  const trackEvent = useCallback(
    (eventName: string, params?: Record<string, any>) => {
      if (window.fbq) {
        window.fbq('track', eventName, params)
      }
    },
    [],
  )

  return { trackEvent }
}
